export interface IColorPalette {
    _id: string,
    user: string,
    name: string,
    colors: {
        d: string,
        r: string,
        m: string,
        f: string,
        s: string,
        l: string,
        t: string,
    },
}

export enum DisplayName {
    Username = "username",
    FirstName = "first",
    FillHu = "full_hu",
    Full = "full",
}

export enum PitchNotation {
    Helmholtz = "hh",
    International = "in",
    UppercaseLetter = "ucl",
    UppercaseHelmholtz = "uhh",
}

export enum RhythmSyllableType {
    Kodaly = "ririTamTi",
    KodalyTiRi = "tiriTamTi",
    KodalyTeTe = "teteTamTi",
    KodalyTiRiTaiTi= "tiriTaiTi",
    KodalyRiRiTaiTi = "ririTaiTi",
    Aussie = "aussie",
    Takadimi = "taKaDiMi",
    Gordon = "gordon",
    Takatiki = "taKaTiKi",
    French = "french",
}

export enum SolfaAudioType {
    Solfa = "solfa",
    Lala = "lala",
    Piano = "piano",
}

export interface IUser {
    facebook?: {
        id?: string,
        connected?: boolean,
    },
    google?: {
        id?: string,
        accessToken?: string,
        connected?: boolean,
    },
    lastLogin: {
        time: number,
        date: string,
    },
    school_types: string[],
    welcome: number,
    _id: string,
    email: string,
    confirmEmail?: string,
    password: boolean | string,
    verificationCode?: string,
    created: number,
    first_name: string,
    last_name: string,
    username: string,
    permission: number,
    birthyear: number,
    language: string,
    gender?: number,
    work_since?: number,
    profiled: boolean,
    profilePicture?: string,
    displayName: DisplayName,
    verifiedEmail?: boolean,
    key?: number,
    motherTongue?: string,
    newsletter?: string,
    
    pitchNotation?: PitchNotation,
    rhythmSyllableType?: RhythmSyllableType,
    solfaAudio?: SolfaAudioType,
    solfaKam: boolean,
    solfaShort?: boolean,
    colors?: number | string | IColorPalette,
    reversedToneset?: boolean,

    settingsNoticed?: boolean,
    state?: "loggedIn",
    moderator?: any,
    isTranslator: boolean,
    loggedIn: boolean,
    premium?: "active" | "suspended",
    isStudent?: boolean,
    isGameAdmin?: boolean,
    limitless?: boolean,
    hint?: boolean,
}

export interface ILoggedOutUser {
    loading?: true | "facebook" | "google";
    error?: boolean;
    validationEmail?: "tooManyAttempts" | "loginError" | "facebookConnectionError" | "googleConnectionError",
    validationPassword?: "1",
    loggedIn?: false,
}

export type IUserState = IUser | ILoggedOutUser | null